(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('EventPlaceDeleteController',EventPlaceDeleteController);

    EventPlaceDeleteController.$inject = ['$uibModalInstance', 'entity', 'EventPlace'];

    function EventPlaceDeleteController($uibModalInstance, entity, EventPlace) {
        var vm = this;
        vm.eventPlace = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            EventPlace.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
